module.exports = __webpack_public_path__ + "img/search-header-with-nav-infiniti.7273d243.png";